import routerOptions0 from "/home/vsts/work/1/s/node_modules/.pnpm/nuxt@3.14.1592_eslint@8.57.0_rollup@4.34.8_typescript@5.9.3_vue-tsc@2.1.6/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}